import React, { useEffect, useMemo } from 'react';
import StepShell from './StepShell';
import DeviceConnectionStatus from './DeviceConnectionStatus';
import type { ConnectionPhase } from './DeviceConnectionStatus';
import type { FlowCtx } from './types';

interface Props {
  ctx: FlowCtx;
}

/** Derive the visual phase from the current status message and popup state. */
function derivePhase(msg: string, popupIsOpen: boolean): ConnectionPhase {
  if (msg.includes('Device connected successfully')) return 'success';
  if (msg.includes('Device hotspot connected')) return 'connected';
  if (popupIsOpen) {
    // Failure after hotspot connected (during wifi send) → red circle with X
    const wasInWifiPhase = msg.includes('Sending Wi-Fi details') || msg.includes('Connecting to internet') || msg.includes('Saving device data');
    return wasInWifiPhase ? 'wifi-failed' : 'failed';
  }
  if (msg.includes('Sending Wi-Fi details') || msg.includes('Connecting to internet') || msg.includes('Saving device data')) return 'wifi-connecting';
  return 'finding';
}

const Step5ConnectToDeviceHotspot: React.FC<Props> = ({ ctx }) => {
  useEffect(() => {
    ctx.autoConnectToDeviceWifi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const phase = useMemo(() => derivePhase(ctx.statusMessage, ctx.popupIsOpen), [ctx.statusMessage, ctx.popupIsOpen]);

  return (
    <StepShell
      stepNumber={3}
      onBack={ctx.openExitModal}
      hideFooter
    >
      <DeviceConnectionStatus
        message={ctx.statusMessage || 'IAQ device trying connecting to WiFi network'}
        paused={ctx.popupIsOpen}
        phase={phase}
      />
    </StepShell>
  );
};

export default Step5ConnectToDeviceHotspot;
